import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { ClipboardList, Printer } from "lucide-react";
import { formatCurrency } from "../../lib/utils";

export default function ViewListDialog({ 
  viewingList, 
  onClose, 
  onPrint
}) {
  return (
    <Dialog open={!!viewingList} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ClipboardList className="w-5 h-5 text-primary" />
            {viewingList?.name}
          </DialogTitle>
          <DialogDescription>
            {viewingList?.items.length} productos · Total estimado: {formatCurrency(viewingList?.total_estimated_cost)}
          </DialogDescription>
        </DialogHeader>

        {viewingList && (
          <div className="rounded-lg border overflow-hidden">
            <Table>
              <TableHeader>
                <TableRow className="bg-muted/50">
                  <TableHead className="w-10 text-center">#</TableHead>
                  <TableHead>Ingrediente</TableHead>
                  <TableHead className="text-right">Cantidad</TableHead>
                  <TableHead className="text-right">Coste est.</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {viewingList.items.map((item, idx) => (
                  <TableRow key={item.ingredient_id || item.ingredient_name || `item-${idx}`}>
                    <TableCell className="text-center text-muted-foreground text-sm">{idx + 1}</TableCell>
                    <TableCell className="font-medium">{item.ingredient_name}</TableCell>
                    <TableCell className="text-right font-mono text-sm">{item.quantity} {item.unit}</TableCell>
                    <TableCell className="text-right font-mono text-sm">{formatCurrency(item.estimated_cost)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cerrar</Button>
          <Button onClick={() => onPrint(viewingList, false)} data-testid="print-full-list-btn">
            <Printer className="w-4 h-4 mr-2" />
            Imprimir / Exportar PDF
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
